import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Container, Nav } from './Layout.style';

const PromptLayout = () => {
	const navigation = useNavigate();
	const { pathname } = window.location;

	return (
		<Container>
			<Nav>
				<button
					className={pathname === '/prompt-manage' ? 'selected' : ''}
					onClick={() => {
						navigation('/prompt-manage');
					}}>
					사용자 관리
				</button>
				<div className='dash'></div>
				<button
					className={pathname === '/prompt' ? 'selected' : ''}
					onClick={() => {
						navigation('/prompt');
					}}>
					페르소나 프롬프트
				</button>
			</Nav>
			<Outlet />
		</Container>
	);
};

export default PromptLayout;
